<template>
	<div class="brick" style="width:1350px;">
		<div class="list_top_box">
			<div class="left_option">
				<!-- <em class="lt_text">SO Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="so_date"/></span> -->
				<em class="lt_text">Sales Order No</em>
				<span class="int_type_no_border mgr_5">
					<SoSelect v-model.trim="so_dn" initialStatusCode="O" :initialFromDaysAgo="user.company_id == 'newjigu' ? 90 : 3" ref="so_dn" ph="Enter SO No or Scan" @set-invoice="setInvoice" @search="selectRequestPrices()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="selectRequestPrices()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>

				<label for="designated" style="margin-left:5px;" class="mgr_15"> <input type="checkbox" id="designated" v-model="designated" />Designated</label>
				<label for="urgent" style="margin-left:5px;color:red;" class="mgr_15"> <input type="checkbox" id="urgent" v-model="urgent" />URGENT</label>
				<!-- #3320 2차: jc 전용. Request P. 가 Original P. 와 다른 행만 본다. 조회할 때마다 해제 상태로 시작한다. -->
				<label v-if="user.company_id == 'jc'" for="differs_only" style="margin-left:5px;" class="mgr_15"> <input type="checkbox" id="differs_only" v-model="differs_only" @change="onDiffersOnlyChange()" />Requested only</label>

				<template v-if="profile.use_temp_flag == 'Y' && invoices.length > 0 && invoices[0].invoice_type == 'S'">
					<label style="margin-left:10px;margin-right:10px;" for="temp_flag"> <input type="checkbox" id="temp_flag" v-model="invoices[0].temp_flag" /> <span style="font-weight:bold;color:blue;">Ship from Georgia</span> </label>
				</template>

				<a v-if="!allApproved && user.so_approval && items.length > 0" href="javascript:;" type="button" class="search_bt mgr_10" @click="save(true)">Approve</a>
				<a v-if="items.length > 0" href="javascript:;" class="search_bt mgr_15" @click="save(false)">Save</a>

				<a v-if="user.company_id == 'newjigu' && invoices.length > 0 && invoices[0].status_code == 'O' && user.so_hold" href="javascript:;" class="gray_bt" style="margin-left:20px;" @click="hold()">Hold</a>
			</div>
		</div>

		<template v-for="invoice in invoices">
			<div class="view_inner" v-bind:key="invoice.invoice_no + '1'">
				<div class="divide_tbl">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:90px;" />
							<col style="width:100px;" />
							<col style="width:90px;" />
							<col style="width:80px;" />
							<col style="width:90px;" />
							<col style="width:250px;" />
							<col style="width:120px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Sales Date</th>
								<td>{{ invoice.so_date }}</td>
								<th>Status</th>
								<td>{{ invoice.status_code | saleStatusName }}</td>
								<th>Ship To</th>
								<td>{{ invoice.ship_to_code }} / {{ invoice.ship_to_name }}</td>
								<th>Sales Group Code</th>
								<td>
									{{ invoice.sales_group_code }} / {{ invoice.sales_group_name }}
									<template v-if="user.company_id == 'newjigu'">
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-weight:bold;">Biz.Type</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										<a v-if="invoice.ship_to_code && arHistoryAccessible" href="javascript:;" type="button" class="search_bt" style="padding: 0px 15px;" @click="gotoArHistory(invoice.ship_to_code, invoice.ship_to_name)"> AR History</a>
									</template>
								</td>
							</tr>
							<tr>
								<th>Total Quantity</th>
								<td>{{ invoice.total_quantity | commaSeparated }}</td>
								<th>Total Amount</th>
								<td>{{ invoice.total_amount | toCurrency }}</td>
								<th><a v-if="invoice.ship_to_code && partnerAccessible" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="gotoPartner(invoice.ship_to_code)">Detail</a></th>
								<td>
									<template v-if="user.company_id == 'newjigu'">{{ invoice.ship_to_city }} </template>{{ invoice.ship_to_state }}, {{ invoice.ship_to_country }}
								</td>
								<th>To Accounting</th>
								<td><input type="text" v-model.trim="invoice.remark" class="tbl_int" placeholder="To Approval or Invoice Staff" @focus="$event.target.select()" /></td>
							</tr>
							<tr v-if="user.company_id == 'newjigu'">
								<th>Valid Quantity</th>
								<td>{{ invoice.total_valid_quantity | commaSeparated }}</td>
								<th>Valid Amount</th>
								<td>
									<span style="font-weight:bold;color:blue;">{{ invoice.total_valid_amount | toCurrency }}</span>
								</td>
								<th>SC / PT / DT</th>
								<td>{{ invoice.ship_charge_name }} / {{ invoice.payment_term_name }} / {{ invoice.delivery_type_name }}</td>
								<th>YTD</th>
								<td>
									<div style="float:left;width:100px;padding-top:4px;">
										<span style="font-weight:bold;color:blue;">{{ invoice.partner_ytd | toCurrency }}</span>
									</div>
									<span style="font-weight:bold;margin-right:10px;">Customer PO No</span>
									<span><input type="text" v-model.trim="invoice.customer_po_no" class="tbl_int sm_int" readonly/></span>
								</td>
							</tr>
							<tr v-else>
								<th>Payment Term</th>
								<td colspan="3">{{ invoice.payment_term_name }}</td>
								<th>Delivery Type</th>
								<td>{{ invoice.delivery_type_name }}</td>
								<th>Ship Charge</th>
								<td>{{ invoice.ship_charge_name }}</td>
							</tr>
							<tr v-if="user.company_id == 'newjigu'">
								<th>To Customer</th>
								<td colspan="3"><input type="text" v-model.trim="invoice.description" class="tbl_int" @focus="$event.target.select()" /></td>
								<th>To Warehouse</th>
								<td><input type="text" v-model.trim="invoice.remark2" class="tbl_int" @focus="$event.target.select()" /></td>
								<th>General Remark</th>
								<td><input type="text" v-model.trim="invoice.general_remark" class="tbl_int" @focus="$event.target.select()" /></td>
							</tr>
							<tr v-if="invoice.main_invoice_no">
								<td colspan="8">
									<b
										>Additional Order of <font color="red">{{ invoice.main_so_dn }}</font></b
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<table class="list_tbl" v-bind:key="invoice.invoice_no + '2'" v-columns-resizable>
				<thead>
					<tr>
						<th width="3%">No</th>
						<th width="8%">Item {{ headers.class }}</th>
						<th v-if="user.company_id != 'jc'" width="12%">Item Color</th>
						<th>Item Name</th>
						<th width="5%"><input v-if="!emptyVisible(invoice.invoice_no)" type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
						<th width="6%">Min Price</th>
						<th width="10%">Original P.<a v-if="!emptyVisible(invoice.invoice_no)" href="javascript:;" class="gray_bt2" style="margin-left:5px;line-height: 18px; height: 18px;" @click="applyAll('original')">Apply</a></th>
						<th width="10%">Request P.<a v-if="!emptyVisible(invoice.invoice_no)" href="javascript:;" class="gray_bt2" style="margin-left:5px;line-height: 18px; height: 18px;" @click="applyAll('requested')">Apply</a></th>
						<th width="6%"><input type="checkbox" v-model="finalPriceCheck" />Final P.</th>
						<th width="5%">Quantity</th>
						<th width="5%">Avail. Qty.</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in getVisibleItems(invoice.invoice_no)" v-bind:key="item.invoice_item_no" v-bind:class="{ on: index == selectedIndex }" @click="selectRow(index)">
						<!-- <tr v-for="item in items" v-bind:key="item.invoice_item_no"> -->
						<!-- <td colspan="3"></td> -->
						<td class="al_right">
							<template v-if="index == 0 || (index > 0 && item.class_code != getVisibleItems(invoice.invoice_no)[index - 1].class_code)">
								<!-- <label :for="'item' + index"><input type="checkbox" :id="'item' + index" v-model="item.class_selected" /> {{ item.class_code }}</label> -->
								{{ item.class_order_no }}
							</template>
						</td>
						<td>
							<template v-if="index == 0 || (index > 0 && item.class_code != getVisibleItems(invoice.invoice_no)[index - 1].class_code)">
								<!-- <label :for="'item' + index"><input type="checkbox" :id="'item' + index" v-model="item.class_selected" /> {{ item.class_code }}</label> -->
								{{ item.class_code }}
							</template>
						</td>
						<td v-if="user.company_id != 'jc'">
							<a href="javascript:;" @click="selectColor(item)">{{ item.color_code }}</a>
						</td>
						<td>
							<a href="javascript:;" @click="selectItem(invoice, item)">{{ item.name }}</a>
						</td>
						<td class="al_center">
							<!-- <template v-show="index == 0 || (index > 0 && item.class_code != getItems(invoice.invoice_no)[index - 1].class_code)"> -->
							<input v-show="index == 0 || (index > 0 && item.class_code != getVisibleItems(invoice.invoice_no)[index - 1].class_code)" type="checkbox" v-model="item.class_selected" @change="selectClassItems(item)" />
							<!-- </template> -->
						</td>
						<td class="al_right">{{ item.min_price | toCurrency }}</td>
						<!-- <td class="al_center"><input type="checkbox" v-model="item.r_confirmed" /></td> -->
						<td class="al_right" :style="(item.r_confirmed ? item.org_price : item.unit_price) == item.final_price ? 'background:yellow' : ''">
							<!-- {{ item.r_confirmed ? item.org_price : item.unit_price | toCurrency }}<a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, item.r_confirmed ? item.org_price : item.unit_price)">Apply</a> -->
							{{ item.r_confirmed ? item.org_price : item.unit_price | toCurrency }}<a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, 'original')">Apply</a>
						</td>
						<!-- <td class="al_right">{{ item.org_price | toCurrency }}</td> -->
						<td class="al_right" :style="item.r_price && item.r_price == item.final_price ? 'background:yellow' : ''">
							<!-- {{ item.r_price | toCurrency }} <a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, item.r_price)">Apply</a> -->
							{{ item.r_price | toCurrency }} <a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, 'requested')">Apply</a>
						</td>
						<td>
							<currency-input
								type="text"
								v-model="item.final_price"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								:ref="'final_price_' + item.invoice_item_no"
								@keydown.down.prevent="goTo('final_price', index + 1, invoice.invoice_no)"
								@keydown.up.prevent="goTo('final_price', index - 1, invoice.invoice_no)"
								@keydown.right.prevent="goTo('quantity', index, invoice.invoice_no)"
								@keydown.enter.prevent="goTo('final_price', index + 1, invoice.invoice_no)"
								@keydown.left.prevent="goTo('quantity', index - 1, invoice.invoice_no)"
								@input="calFinalPrice(item)"
							/>
						</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model="item.quantity"
								:precision="0"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								:ref="'quantity_' + item.invoice_item_no"
								@keydown.down.prevent="goTo('quantity', index + 1, invoice.invoice_no)"
								@keydown.up.prevent="goTo('quantity', index - 1, invoice.invoice_no)"
								@keydown.right.prevent="goTo('final_price', index + 1, invoice.invoice_no)"
								@keydown.enter.prevent="goTo('quantity', index + 1, invoice.invoice_no)"
								@keydown.left.prevent="goTo('final_price', index, invoice.invoice_no)"
							/>
						</td>
						<td class="al_right">
							<span :style="item.available_quantity <= 0 ? 'font-weight:bold;color:red;' : 'font-weight:normal;color:black;'">
								{{ item.available_quantity | commaSeparated }}
							</span>
						</td>
					</tr>
					<!-- #3320 2차: 필터 ON 인데 표시할 행이 없을 때. jc 에서만 도달한다. -->
					<tr v-if="emptyVisible(invoice.invoice_no)">
						<td colspan="10" class="al_center">No items with a different request price</td>
					</tr>
				</tbody>
			</table>
		</template>

		<table class="list_tbl" v-if="false">
			<thead>
				<tr>
					<!-- <th width="8%">S/O No</th>
					<th width="7%">S/O Date</th>
					<th width="5%">Status</th> -->
					<!-- <th width="8%">Ship / Item Class</th> -->
					<th width="8%">Item {{ headers.class }}</th>
					<!-- <th width="12%">Ship / Item Color</th> -->
					<th width="12%">Item Color</th>
					<!-- <th width="9%">Sales Grp. / Item Name</th> -->
					<th>Item Name</th>
					<th width="7%">Total Qty.</th>
					<th width="9%">Total Amt.</th>
					<!-- <th width="3%"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th> -->
					<th width="10%">Original P.</th>
					<th width="10%">Request P.</th>
					<th width="6%">Final P.</th>
					<th width="5%">Quantity</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="invoice in invoices">
					<tr v-for="(item, index) in getItems(invoice.invoice_no)" v-bind:key="item.invoice_item_no">
						<!-- <tr v-for="item in items" v-bind:key="item.invoice_item_no"> -->
						<!-- <td colspan="3"></td> -->
						<td>
							<template v-if="index == 0 || (index > 0 && item.class_code != getItems(invoice.invoice_no)[index - 1].class_code)">
								<label :for="'item' + index"><input type="checkbox" :id="'item' + index" v-model="item.class_selected" /> {{ item.class_code }}</label>
							</template>
						</td>
						<td>
							<a href="javascript:;" @click="selectColor(item)">{{ item.color_code }}???</a>
						</td>
						<td colspan="3">
							<a href="javascript:;" @click="selectItem(item)">{{ item.name }}</a>
						</td>
						<!-- <td class="al_center"><input type="checkbox" v-model="item.r_confirmed" /></td> -->
						<td class="al_right" :style="(item.r_confirmed ? item.org_price : item.unit_price) == item.final_price ? 'background:yellow' : ''">
							<!-- {{ item.r_confirmed ? item.org_price : item.unit_price | toCurrency }}<a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, item.r_confirmed ? item.org_price : item.unit_price)">Apply</a> -->
							{{ item.r_confirmed ? item.org_price : item.unit_price | toCurrency }}<a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, 'original')">Apply</a>
						</td>
						<!-- <td class="al_right">{{ item.org_price | toCurrency }}</td> -->
						<td class="al_right" :style="item.r_price && item.r_price == item.final_price ? 'background:yellow' : ''">
							<!-- {{ item.r_price | toCurrency }} <a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, item.r_price)">Apply</a> -->
							{{ item.r_price | toCurrency }} <a href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="apply(item, 'requested')">Apply</a>
						</td>
						<td>
							<currency-input
								type="text"
								v-model="item.final_price"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								ref="final_price"
								@keydown.down.prevent="goTo('final_price', index + 1)"
								@keydown.up.prevent="goTo('final_price', index - 1)"
								@keydown.right.prevent="goTo('quantity', index)"
								@keydown.enter.prevent="goTo('final_price', index + 1)"
								@keydown.left.prevent="goTo('quantity', index - 1)"
								@input="calFinalPrice(item)"
							/>
						</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model="item.quantity"
								:precision="0"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								ref="quantity"
								@keydown.down.prevent="goTo('quantity', index + 1)"
								@keydown.up.prevent="goTo('quantity', index - 1)"
								@keydown.right.prevent="goTo('final_price', index + 1)"
								@keydown.enter.prevent="goTo('quantity', index + 1)"
								@keydown.left.prevent="goTo('final_price', index)"
							/>
						</td>
					</tr>
					<!-- <tr v-bind:key="invoice.invoice_no">
						<td class="al_left">
							<a href="javascript:;" @click="selectSO(invoice)"
								><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font></a
							>
						</td>
						<td class="al_left">{{ invoice.so_date }}</td>
						<td class="al_left">{{ invoice.status_code | saleStatusName }}</td>
						<td class="al_left">
							<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_code }}</a>
						</td>
						<td class="al_left truncate">
							<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_name }}</a>
						</td>

						<td class="al_left">{{ invoice.sales_group_name }}</td>
						<td class="al_right">{{ invoice.total_quantity | commaSeparated }}</td>
						<td class="al_right">{{ invoice.total_amount | toCurrency }}</td>

						<td class="al_left" colspan="4">{{ invoice.remark }}</td>
					</tr> -->
				</template>
			</tbody>
		</table>

		<div class="bottom_bt_box">
			<ul>
				<a v-if="!allApproved && user.so_approval && items.length > 0" href="javascript:;" type="button" class="search_bt mgr_10" @click="save(true)">Approve</a>
				<a v-if="items.length > 0" href="javascript:;" class="search_bt mgr_15" @click="save(false)">Save</a>

				<a v-if="user.company_id == 'newjigu' && invoices.length > 0 && invoices[0].status_code == 'O' && user.so_hold" href="javascript:;" class="gray_bt" style="margin-left:20px;" @click="hold()">Hold</a>
			</ul>
		</div>
	</div>
</template>

<script>
// import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectRequestPriceList, apiUpdateRequestPrice, apiHoldSalesOrder } from '@/api/sales/invoice.js';
// import Paging from '@/components/common/Paging';
//import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
// import CodeSelect from '@/components/common/CodeSelect';
// import PartnerSelect from '@/components/common/PartnerSelect';
import SoSelect from '@/components/common/SoSelect';
import { today, isDate } from '@/utils/date.js';

export default {
	props: ['headers'],
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'N',

			so_dn: null,
			so_date: today(),

			invoices: [],
			items: [],

			allSelected: true,
			designated: false,
			urgent: false,
			finalPriceCheck: false,
			// #3320 2차: jc 전용 표시 필터. 조회할 때마다 false 로 되돌린다.
			differs_only: false,

			selectedIndex: null,
		};
	},
	watch: {
		so_date: function(newVal) {
			if (newVal && isDate(newVal)) this.selectRequestPrices();
		},
		items: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
	},
	computed: {
		// modifiable() {
		// 	var menus = this.$session.get('menus');
		// 	for (var i = 0; i < menus.length; i++) {
		// 		if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
		// 	}
		// 	return false;
		// },
		user: function() {
			return this.$session.get('user');
		},
		// #3320 2차: 신호가 모든 행에 실려 있을 때만 필터를 켠다. 구 API 응답(키 없음)에서는 기존 동작으로 돌아간다.
		signalPresent() {
			return this.items.length > 0 && this.items.every(i => typeof i.r_price_differs !== 'undefined');
		},
		// #3320 2차: 회사 검사를 가장 먼저 평가한다. 거짓이면 아래 모든 분기가 변경 전과 같아진다.
		filterActive() {
			return this.user.company_id == 'jc' && this.differs_only && this.signalPresent;
		},
		profile: function() {
			return this.$session.get('profile');
		},
		allApproved() {
			return this.invoices.filter(i => i.status_code != 'A').length == 0 ? true : false;
		},
		partnerAccessible() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if (menus[i].path == '/partner/detail' && menus[i].view_yn == 'Y') return true;
			}
			return false;
		},
		arHistoryAccessible() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if (menus[i].path == '/receipt/ar_history' && menus[i].view_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		//CustomDatePicker,
		SoSelect,
	},
	methods: {
		selectItem(invoice, item) {
			if (this.user.company_id == 'newjigu') {
				let routeData = this.$router.resolve({ name: 'itemInquiry', query: { backUri: this.uri, partner_code: invoice.ship_to_code, class_code: item.class_code } });
				window.open(routeData.href, 'herp_item_inquiry');
			} else {
				let routeData = this.$router.resolve({ name: 'itemMaster', params: {}, query: { backUri: this.uri, keyword: item.item_id } });
				window.open(routeData.href, 'herp_item');
			}
		},
		selectColor(item) {
			let routeData = this.$router.resolve({ name: 'salesGoods', query: { backUri: this.uri, class_code: item.class_code, color_code: item.color_code } });
			window.open(routeData.href, 'herp_sales_goods');
		},
		hold() {
			var vm = this;
			this.$alertify.prompt(
				'General Remark',
				this.invoices[0].general_remark ? this.invoices[0].general_remark : '',
				function(evt, value) {
					//console.log('You entered: ' + value);
					//console.log(this.invoices[0].invoice_no, value);
					vm.holdConfirm(value);
				},
				function() {
					//console.log('Cancel');
				},
			);
		},
		async gotoPartner(partner_code) {
			let routeData = this.$router.resolve({ name: 'partnerDetail', query: { backUri: this.uri, code: partner_code }, params: { mode: 'detail' } });
			window.open(routeData.href, 'herp_partner');
		},
		async gotoArHistory(partner_code, partner_name) {
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.uri, bill_to_code: partner_code, bill_to_name: partner_name } });
			window.open(routeData.href, 'herp_ar_history');
		},
		async holdConfirm(general_remark) {
			var invoice = this.invoices[0];
			invoice.status_code = 'H';
			invoice.general_remark = general_remark;
			//var param = { invoice_no: this.invoices[0].invoice_no, general_remark: general_remark };
			//console.log(invoice);

			const { data } = await apiHoldSalesOrder(invoice);
			if (data.result) {
				this.$toast.success('Saved Successfully');
				this.reset();
			} else {
				this.$toast.error(data.msg);
			}

			//console.log(this.invoices[0].invoice_no, general_remark);
		},
		calFinalPrice(item) {
			if (this.finalPriceCheck) {
				this.items
					.filter(i => i.class_code == item.class_code && i.class_selected && i.invoice_item_no != item.invoice_item_no && i.unit_price > 0)
					.forEach(fi => {
						fi.final_price = fi.unit_price + item.final_price - item.unit_price;
					});
			}
			this.calTotal();
		},
		calTotal() {
			var vm = this;
			//console.log('cal_total');
			this.invoices.forEach(function(invoice) {
				//invoice.items = vm.getItems(invoice.invoice_no).filter(it => it.final_price);
				var items = vm.getItems(invoice.invoice_no);
				//console.log(items);
				var total_amount = 0;
				var total_quantity = 0;
				var total_valid_amount = 0;
				var total_valid_quantity = 0;

				items.forEach(function(item) {
					total_quantity += item.quantity;
					if (vm.hasFinalPrice(item)) total_amount += item.final_price * item.quantity;
					else total_amount += item.unit_price * item.quantity;

					var effective_price;
					if (!item.r_price && typeof item.r_price === 'object') effective_price = item.unit_price;
					else effective_price = item.r_price;

					if (vm.user.company_id == 'beautyplus' && item.final_price > 0) {
						effective_price = item.final_price;
					}

					item.valid_quantity = item.available_quantity > item.quantity ? item.quantity : item.available_quantity > 0 ? item.available_quantity : 0;
					item.valid_amount = item.valid_quantity * effective_price;

					total_valid_quantity += item.valid_quantity;
					total_valid_amount += item.valid_amount;
				});
				invoice.total_quantity = total_quantity;
				invoice.total_amount = total_amount;
				invoice.total_valid_quantity = total_valid_quantity;
				invoice.total_valid_amount = total_valid_amount;
			});
		},
		goTo(colType, index, invoice_no) {
			this.$nextTick(() => {
				// Vue 2의 v-for ref 배열은 필터 복원 후 DOM 순서와 다를 수 있다.
				// 화면 행의 품목 ID로 찾으면 재생성 순서나 다른 주문의 ref에 영향받지 않는다.
				const item = this.getVisibleItems(invoice_no)[index];
				const refs = item && this.$refs[colType + '_' + item.invoice_item_no];
				if (refs && refs[0]) refs[0].$el.select();
				this.selectedIndex = index;
			});
		},
		selectRow(index) {
			this.selectedIndex = index;
		},
		apply(item, type) {
			//console.log(item, price);
			//console.log(item);
			var price;
			var filter_items = this.items.filter(i => i.class_code == item.class_code && i.class_selected);

			if (filter_items.length > 0) {
				//if (this.items.filter(i => i.class_selected).length > 0) {
				//console.log('class selected');
				filter_items
					//.filter(i => i.class_code == item.class_code)
					//.filter(i => i.class_code == item.class_code && i.class_selected)
					.forEach(function(item2) {
						//console.log(item);
						if (type == 'original') price = item2.r_confirmed ? item2.org_price : item2.unit_price;
						else if (type == 'requested') price = item2.r_price;

						if (price === null) price = item2.unit_price;

						item2.final_price = price;
					});
			} else {
				if (type == 'original') price = item.r_confirmed ? item.org_price : item.unit_price;
				else if (type == 'requested') price = item.r_price;

				item.final_price = price;
			}

			this.$forceUpdate();
			this.calTotal();
		},
		applyAll(type) {
			if (this.user.company_id == 'beautyplus' && type == 'original') {
				if (!confirm('Are you sure to apply original price?')) {
					return;
				}
			}

			var price;
			this.items
				.filter(i => i.class_selected)
				.forEach(item2 => {
					if (type == 'original') price = item2.r_confirmed ? item2.org_price : item2.unit_price;
					else if (type == 'requested') price = item2.r_price;

					if (price === null) price = item2.unit_price;

					item2.final_price = price;
				});

			this.$forceUpdate();
			this.calTotal();
		},
		setInvoice() {
			this.selectRequestPrices();
		},
		reset() {
			this.invoices = [];
			this.items = [];
			this.so_dn = null;
			this.allSelected = true;
			this.finalPriceCheck = false;
			this.selectedIndex = null;

			this.$refs.so_dn.$el.children[0].focus();
		},
		async save(approval) {
			if (this.invoices.filter(i => i.partner_blocked).length > 0) {
				this.$toast.error('Blocked Account');
				return;
			}

			if (this.items.length == 0) {
				this.$toast.error('Nothing to save');
				return;
			}

			if (approval && this.gateItems().filter(i => i.r_price && !i.final_price).length > 0) {
				this.$toast.error('To approve, all final price of the items with request price must be set');
				return;
			}
			var vm = this;
			//console.log(this.items);
			this.items
				//.filter(it => it.final_price)
				.forEach(function(item) {
					// if (item.r_confirmed) {
					// 	item.r_confirmed = 1;
					// 	item.org_price = item.unit_price;
					// 	item.unit_price = item.r_price;
					// } else {
					// 	item.r_confirmed = 0;
					// 	if (item.org_price) item.unit_price = item.org_price;
					// }
					if (item.final_price >= 0) {
						if (!item.r_confirmed) {
							//처음 confirm 됨
							item.r_confirmed = 1;
							item.org_price = item.unit_price;
						}

						item.unit_price = item.final_price;
					}
					item.amount = item.unit_price * item.quantity;
				});

			this.invoices.forEach(function(invoice) {
				invoice.items = vm.getItems(invoice.invoice_no); //.filter(it => it.final_price);
				if (approval) invoice.status_code = 'A';
			});

			//var param = { invoices: this.invoices };
			var param = { invoices: this.invoices, designated: this.designated, urgent: this.urgent };
			if (approval) param.approval = true;

			const { data } = await apiUpdateRequestPrice(param);
			if (data.result) {
				this.$toast.success('Saved Successfully');
				await this.selectRequestPrices();
				this.$nextTick(function() {
					this.$refs.so_dn.$el.children[0].focus();
				});
			} else {
				this.$toast.error(data.msg);
			}

			//console.log(this.invoices);
		},
		selectClassItems(item) {
			this.items
				.filter(i => i.class_code == item.class_code)
				.forEach(i => {
					// #3320 2차: 숨긴 행은 항상 false.
					i.class_selected = this.hiddenRow(i) ? false : item.class_selected;
				});
		},
		selectAll() {
			var vm = this;
			this.items.forEach(function(item) {
				// #3320 2차: 숨긴 행은 항상 false. 필터 OFF·타사에서는 hiddenRow 가 거짓이라 기존과 같다.
				item.class_selected = vm.hiddenRow(item) ? false : vm.allSelected;
			});
		},
		getItems(invoice_no) {
			return this.items.filter(i => i.invoice_no == invoice_no);
		},
		// #3320 2차: 표시 전용. getItems 는 합계·저장이 계속 쓰므로 그대로 둔다.
		hiddenRow(item) {
			return this.filterActive && item.r_price_differs !== true;
		},
		getVisibleItems(invoice_no) {
			return this.getItems(invoice_no).filter(i => !this.hiddenRow(i));
		},
		emptyVisible(invoice_no) {
			return this.filterActive && this.getVisibleItems(invoice_no).length == 0;
		},
		// #3320 2차: 필터 ON 에서만 Final P. 0 을 입력값으로 본다. OFF·타사는 기존 truthiness 그대로.
		hasFinalPrice(item) {
			if (this.filterActive) return !(item.final_price === null || item.final_price === undefined || item.final_price === '');
			return !!item.final_price;
		},
		// #3320 2차: 승인 게이트 대상. 판정 식은 그대로 두고 대상 행만 좁힌다.
		gateItems() {
			if (!this.filterActive) return this.items;
			return this.items.filter(i => !this.hiddenRow(i));
		},
		// #3320 2차: 전환 시 선택 상태만 재설정하고 사용자가 입력한 final_price 는 보존한다.
		// watcher 는 items 변경만 보므로 값이 그대로면 발화하지 않는다. 합계를 명시적으로 갱신한다.
		onDiffersOnlyChange() {
			this.selectAll();
			this.calTotal();
		},
		selectSO(invoice) {
			this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		// gotoPartner(code) {
		// 	this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		// },
		async selectRequestPrices() {
			//console.log(this.so_date);
			const { data } = await apiSelectRequestPriceList({
				//so_date: this.so_date,
				so_dn: this.so_dn,
			});
			//console.log(data);
			this.invoices = data.invoiceList;
			this.items = data.invoiceItemList;

			var prev_class_code = null;
			var class_order_no = 0;
			this.items.forEach(function(i) {
				if (i.class_code != prev_class_code) {
					class_order_no++;
					prev_class_code = i.class_code;
				}
				i.class_order_no = class_order_no;

				if (i.r_confirmed) i.final_price = i.unit_price;
				//else i.final_price = i.r_price;
			});

			if (this.invoices.length > 0) {
				this.designated = this.invoices[0].designated;
				this.urgent = this.invoices[0].urgent_yn == 'Y' ? true : false;
			}

			this.selectedIndex = null;
			this.allSelected = true;
			this.finalPriceCheck = false;
			this.differs_only = false;
			this.selectAll();
			//this.applyAll('requested');

			var uri = '/sales/request_price?dummy=';
			if (this.so_dn) uri += '&so_dn=' + this.so_dn;
			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);

			if ((this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') && this.invoices.filter(i => i.status_code == 'H').length > 0) {
				this.$alertify.alert('Alert', 'Holded Sales Order');
			}
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_request_price');
		this.$store.commit('setSubTitle', 'Sales -> Approved Price');

		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		if (this.$route.query.so_dn) {
			this.so_dn = this.$route.query.so_dn;
			this.selectRequestPrices();
		}
		//this.selectInvoices();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		this.$nextTick(function() {
			this.$refs.so_dn.$el.children[0].focus();
		});
	},
};
</script>

<style></style>
